export function cardLinker(cardSelector) {
  const cards = document.querySelectorAll(cardSelector);

  cards.forEach((card) => {
    const hrefs = new Set();
    const links = card.querySelectorAll("[href]");
    links.forEach((link) => hrefs.add(link.getAttribute("href")));

    if (hrefs.size === 1) {
      card.addEventListener("click", (event) => {
        console.log({ click_target: event.target, href: [...hrefs][0] });
        window.location.href = [...hrefs][0];
      });
    }
  });
}
